import { call, options, params } from './helpers';

export const getManufacturers = (payload) =>
	call(`/beta/assets/manufacturers${params(payload)}`);
export const getModels = (payload) =>
	call(`/beta/assets/models${params(payload)}`);

export const updateManufacturer = ({ id, name }) =>
	call(`/beta/assets/manufacturers/${id}`, options({ name }, 'PUT'));

export const updateModel = ({ id, name }) =>
	call(`/beta/assets/models/${id}`, options({ name }, 'PUT'));

export const getAssets = (payload) => call(`/beta/assets${params(payload)}`);

export const getArchivedAssets = (payload) =>
	call(`/beta/assets${params(payload)}/all/archived`);

export const addAssets = (payload) =>
	call(`/beta/assets`, options(payload, 'POST'));

export const getAsset = ({ id }) => call(`/beta/assets/${id}`);

export const getPublicAsset = ({ tag, organizationId }) =>
	call(`/beta/assets/tags/${tag}/public?organizationId=${organizationId}`);

export const updateAsset = (payload) =>
	call(`/beta/assets/${payload.id}`, options(payload, 'PUT'));

export const addAssetContacts = (payload) =>
	call(`/beta/assets/${payload.id}/contacts/add`, options(payload, 'PUT'));

export const removeAssetContact = (payload) =>
	call(`/beta/assets/${payload.id}/contacts/remove`, options(payload, 'PUT'));

export const archiveAsset = (payload) =>
	call(`/beta/assets/${payload.id}/archive`, options(null, 'PUT'));

export const unarchiveAsset = (payload) =>
	call(`/beta/assets/${payload.id}/unarchive`, options(null, 'PUT'));

export const deleteAsset = ({ id }) =>
	call(`/beta/assets/${id}`, options(null, 'DELETE'));

export const removeAssetDocument = (payload) =>
	call(`/beta/assets/${payload.id}/documents/remove`, options(payload, 'PUT'));

export const getAssetWidgetData = ({ id, widgetId }) =>
	call(`/beta/assets/${id}/widgets/${widgetId}`);

// Reservable assets endpoints
export const getReservableAssets = () => call(`/v2/assets/reservable`);

export const getNonReservableAssets = () => call(`/v2/assets/non-reservable`);

export const setAssetReservable = (payload) =>
	call(`/v2/assets/reservable`, options(payload, 'PATCH'));

// Asset Groups endpoints
export const getAssetGroups = () => call(`/v2/asset-groups`);

export const getAssetGroup = ({ groupId }) => call(`/v2/asset-groups/${groupId}`);

export const createAssetGroup = (payload) =>
	call(`/v2/asset-groups`, options(payload, 'POST'));

export const updateAssetGroup = (payload) =>
	call(`/v2/asset-groups/${payload.groupId}`, options(payload, 'PUT'));

export const deleteAssetGroup = ({ groupId }) =>
	call(`/v2/asset-groups/${groupId}`, options(null, 'DELETE'));

export const addAssetToGroup = ({ groupId, assetId }) =>
	call(`/v2/asset-groups/${groupId}/assets`, options({ assetId }, 'POST'));

export const removeAssetFromGroup = ({ groupId, assetId }) =>
	call(`/v2/asset-groups/${groupId}/assets/${assetId}`, options(null, 'DELETE'));
